export default {
  props: {
    price: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  }
}
